import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import Modal from 'react-modal';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
//import DialogContainer from './Dialogs/DialogContainer';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import OrganizationForm from './OrganizationForm.js';
import CreateOrganizationForm from './CreateOrganizationForm.js';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import GridDateFormatter from '../../../GridDateFormatter';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { OrganizationsLoader } from './OrganizationsLoader';
import { auth } from '../../../../../services/auth.service';
import ManageUsersForm from './ManageUsersForm.js';

const FileDownload = require('js-file-download');

export class ManageOrganizations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            organizationInEdit: {},
            isPopupVisible: false,
            isManageUsersVisible: false,
            isNewOrganization: false,
            organizations: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "organizationId", dir: "desc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {
        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (organizationsFetched) => {
        // console.log(organizationsFetched);
        this.setState({
            ...this.state,
            organizations: organizationsFetched,
            isLoading: false
        });

        if (organizationsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (organizationsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            organizationInEdit: this.cloneOrganization(dataItem),
            isPopupVisible: true,
            isNewOrganization: false
        });
    };

    manageUsers = (dataItem) => {
        console.log('manage users', dataItem);
        this.setState({
            organizationInEdit: this.cloneOrganization(dataItem),
            isPopupVisible: false,
            isManageUsersVisible: true
        });
    };

    cloneOrganization(event) {
        console.log('cloneOrganization');
        var t = Object.assign({}, event);
        
        return t;
    }

    cancel = () => {
        this.setState({
            isPopupVisible: false,
            isManageUsersVisible: false
        })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };

                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageOrganization/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Organizations.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            organizationInEdit: {},
            isNewOrganization: true
        });
    }

    create = (model) => {
        console.log('create', model)
        // Remove front-end state Object for DropDownList
        delete model.state;

        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                sort: [{ field: "organizationId", dir: "desc" }]
            },
        });

        var url = `${ROOT_API_URL}/ManageOrganization/CreateOrganization`;
        const options = { method: 'POST', headers: auth.authHeader() };

        axios
            .post(url, model, options)
            .then((response) => {
                console.log('response', response)
                this.setState({
                    isSubmitted: false
                });
                this.cancel();
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to craete the organization.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    save = (model) => {
        console.log(model)
        // Remove front-end state Object for DropDownList
        delete model.state;

        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                sort: [{ field: "organizationId", dir: "desc" }]
            },
        });

        var url = `${ROOT_API_URL}/ManageOrganization/SaveOrganization`;
        const options = { method: 'POST', headers: auth.authHeader() };

        axios
            .post(url, model, options)
            .then((response) => {
                console.log('response', response)
                this.setState({
                    isSubmitted: false
                });
                this.cancel();
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the organization.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    toggleActive = (dataItem) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                sort: [{ field: "organizationId", dir: "desc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageOrganization/DeleteOrganization`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the organization.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"memberhips-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading organizations" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.organizations.total}
                                {...this.state.dataState}
                                {...this.state.organizations}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageOrganization/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column field="Email" title="Email" filter="text" />
                                <Column field="OrganizationName" title="Organization Name" filter="text" />
                                <Column field="FirstName" title="First Name" filter="text" />
                                <Column field="LastName" title="Last Name" filter="text" />
                                <Column field="MembershipType" title="Membership Package" filter="text" />
                                <Column field="MembershipNumber" title="Membership Number" filter="text" />
                                <Column field="AdditionalMemberships" title="Additional Memberships" filter="text" />
                                <Column field="RemainingMemberships" title="Remaining Memberships" filter="text" />
                                <Column width={400} filterable={false} cell={cellWithEditing(this.edit, this.manageUsers, this.toggleActive)} /> 
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted?
                        <OrganizationsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>

                    {
                        this.state.isPopupVisible && !this.state.isManageUsersVisible && !this.state.isNewOrganization ? (
                            <OrganizationForm
                                dataItem={this.state.organizationInEdit}
                                save={this.save}
                                cancel={this.cancel}
                                saveAdminOrganization={this.props.saveOrganization}
                            />
                        ) : ""
                    }
                    {
                        this.state.isPopupVisible && !this.state.isManageUsersVisible && this.state.isNewOrganization ? (
                            <CreateOrganizationForm
                                dataItem={this.state.organizationInEdit}
                                create={this.create}
                                cancel={this.cancel}
                                saveAdminOrganization={this.props.saveOrganization}
                            />
                        ) : ""
                    }
                    {
                        this.state.isManageUsersVisible && !this.state.isPopupVisible ? (
                            <ManageUsersForm
                                selectedOrganization={this.state.organizationInEdit}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

export default ManageOrganizations;
